<template>
  <div class="login">
    <b-card class="center_card">
      <h2 class="title mb-2">Bienvenue sur Sivercoh</h2>
      <p class="title">système d'information développé pour vérifier la cohérence des données</p>
      <h4 class="title mb-4">Veuillez vous connecter pour y accéder</h4>
      <b-row no-gutters>
        <b-col md="6">
          <b-card-text>
            <img src="@/assets/login.png" style="width:150px">
          </b-card-text>
        </b-col>
        <b-col md="6">
          <form @submit.prevent="onSubmit">
            <b-form-group label-class="font-weight-bold" label-size="lg" label-align="left">
              <b-input-group>
                <template #prepend>
                  <b-input-group-text variant="primary">
                    <i class="fas fa-user"></i>
                  </b-input-group-text>
                </template>
                <Field
                    name="login"
                    as="b-form-input"
                    placeholder="Identifiant (ldap)"
                    size="xs"
                    title="Login"
                    type="text"
                    v-model="login"
                    class="form-control"
                />
              </b-input-group>
              <ErrorMessage name="login" class="text-danger" />
            </b-form-group>
            <b-form-group label-class="font-weight-bold" label-size="lg" label-align="left">
              <b-input-group>
                <template #prepend>
                  <b-input-group-text>
                    <i class="fas fa-lock"></i>
                  </b-input-group-text>
                </template>
                <Field
                    name="password"
                    as="b-form-input"
                    placeholder="Mot de passe"
                    size="xs"
                    title="Mot de passe"
                    :type="fieldType"
                    v-model="password"
                    class="form-control"
                />
                <b-input-group-text @click.prevent="toggleShow">
                  <i id="showPassword" class="fas" :class="{'fa-eye-slash': fieldType === 'text', 'fa-eye': fieldType === 'password'}"></i>
                </b-input-group-text>
              </b-input-group>
              <ErrorMessage name="password" class="text-danger" />
            </b-form-group>
            <div>
              <b-button type="submit">Se connecter</b-button>
              <p v-if="loginErrorMessage" class="text-danger">{{ loginErrorMessage }}</p>
              <p class="mdp mt-2">
                <router-link :to="{ name: 'MotDePasseOublie'}" class="mdp">mot de passe oublié</router-link>
              </p>
            </div>
          </form>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useForm, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import store from '@/store';
import router from '@/router';

export default {
  name: 'LoginForm',
  components: {
    Field,
    ErrorMessage
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    const login = ref('');
    const password = ref('');
    const fieldType = ref('password');
    const loginErrorMessage = ref('');

    const schema = yup.object({
      login: yup.string().required('Identifiant requis'),
      password: yup.string().required('Mot de passe requis'),
    });

    const { handleSubmit } = useForm({
      validationSchema: schema,
    });

    const toggleShow = () => {
      fieldType.value = fieldType.value === 'password' ? 'text' : 'password';
    };

    const onSubmit = handleSubmit(async (values) => {
      const dataUser = { username: values.login, password: values.password };

      try {
        await store.dispatch('login', dataUser);
        router.push('/');
      } catch (error) {
        loginErrorMessage.value = 'Identifiant ou mot de passe incorrect.';
        setTimeout(() => {
          loginErrorMessage.value = '';  // Clear the message after 5 seconds
        }, 5000);
      }
    });

    return {
      login,
      password,
      fieldType,
      loginErrorMessage,
      toggleShow,
      onSubmit,
    };
  },
};
</script>


<style scoped>

.title{
    color:white;
}
.card.center_card{
  margin:13em auto;
  padding-top:20px;
  padding-bottom:20px;
  width:40%;
  background-color: #00a3a6;
  color : #17a2b8;
  border:none;
}
.mdp{
  color: #ed6e6c;
}

.mdp:hover{
  color: red !important;
}
.mdpTitre{
  color: black;
}

</style>